<script setup lang="ts">
import Typography from '@components/Typography.vue';
import { AddressService } from '@models/types/addressService';
import { OfficeOfferService } from '@models/types/officeOfferService';
import CheckableTagGroup from '@pages/search/components/filters/CheckableTagGroup.vue';
import { trans } from '@tools/translation.ts';

interface ContractTypeProps {
  selected?: string[];
}

const { selected = [] } = defineProps<ContractTypeProps>();

const emit = defineEmits<{(e: 'update:selected', value: string[]): void}>();

const categories = {
  internet: [
    AddressService.WIFI,
    OfficeOfferService.DEDICATED_NETWORK,
    AddressService.FIBER,
    OfficeOfferService.ACCESS_SERVER,
    OfficeOfferService.RJ45,
  ],
  comfort: [
    AddressService.PETS_ALLOWED,
    AddressService.ERP,
    AddressService.WAITING_ROOM,
    AddressService.RELAXATION_AREA,
    AddressService.SHARED_KITCHEN,
    OfficeOfferService.HOUSEHOLD,
    OfficeOfferService.TEA_ROOM,
    AddressService.HANDICAP_ACCESS,
    OfficeOfferService.AC,
  ],
  equipments: [
    OfficeOfferService.TABLES_CHAIRS,
    OfficeOfferService.PRINTER,
  ],
  services: [
    AddressService.PHONEBOX_COUNT,
    OfficeOfferService.STORAGE_POINT,
    OfficeOfferService.PRIVATE_MEETING_ROOM,
    AddressService.PAYABLE_PARKING,
    AddressService.MAIL,
    AddressService.FREE_PARKING,
    AddressService.DOMICILIATION,
    AddressService.BIKE_PARKING,
  ],
  security: [
    OfficeOfferService.SEPARATE_ENTRANCE,
    OfficeOfferService.LOCKER,
    AddressService.BADGE_ACCESS,
  ],
};
</script>

<template>
  <div>
    <div
      v-for="(services, category) in categories"
      :key="category"
    >
      <Typography
        variant="sub-heading"
        color="gray-darker"
        class="py-3"
      >
        {{ trans(`search.filters.other_filters.services.${category}`) }}
      </Typography>

      <CheckableTagGroup
        :options="services"
        :selected="selected"
        :translation-prefix="`search.filters.other_filters.services`"
        @update:selected="emit('update:selected', $event)"
      />
    </div>
  </div>
</template>
